// PDP sticky Sub-nav Desktop & Mobile
document.addEventListener('DOMContentLoaded', function() {
  let isDesktop = window.innerWidth >= 1024;
  let scrollHandler;
  let resizeHandler;
  const desktopMenuList = document.getElementById('desktop-menu-list');
  const mobileMenuList = document.getElementById('mobile-menu-list');
  const sections = document.querySelectorAll('.link-section');
  let desktopEvent = new CustomEvent('buildPDPStickyNavDesktop');
  let mobileEvent = new CustomEvent('buildPDPStickyNavMobile');

  function createMenuItems(menuList, linkClass) {
    sections.forEach(section => {
      const sectionId = section.parentElement.id;
      const sectiontitle = section.parentElement.getAttribute('data-title');
      const li = document.createElement('li');
      if (!section.parentElement.classList.contains('d-none')) {
        li.className =
          menuList === desktopMenuList
            ? 'sub-nav__menu-wrapper__menu-list__item sub-nav-menu-item'
            : 'mobile-list__menu-list__item mobile-list-menu-item';
      } else {
        li.className =
          menuList === desktopMenuList
            ? 'sub-nav__menu-wrapper__menu-list__item sub-nav-menu-item d-none'
            : 'mobile-list__menu-list__item mobile-list-menu-item d-none';
      }
      li.id = `StickyCTA-${sectionId}`;
      const a = document.createElement('a');
      a.className = linkClass;
      a.href = `#${sectionId}`;
      a.textContent = sectiontitle;
      li.appendChild(a);
      menuList.appendChild(li);
    });

    // Add smooth scrolling
    const links = document.querySelectorAll(`.${linkClass}`);
    links.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        const viewportWidth = window.innerWidth;
        const offset = viewportWidth >= 768 ? 30 : 105;

        window.scrollTo({
          top: targetElement.offsetTop - offset,
          behavior: 'smooth'
        });
      });
    });
  }

  function initStickyAtcSuppress() {
    const stickyBar = document.querySelector('.product-sticky-menu-main');
    if (!stickyBar) return;

    // Find the on-page ATC button container
    const atcButtons = document.querySelector('.product__info-wrapper .product-form__buttons')
                    || document.querySelector('.product-form__buttons');
    if (!atcButtons) return;

    // Start with sticky bar suppressed
    stickyBar.classList.add('pdp-ux-sticky-suppressed');

    // Observe the on-page ATC button visibility
    const observer = new IntersectionObserver(function(entries) {
      const entry = entries[0];

      // Check if ATC has scrolled above viewport (not just out of view)
      if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
        // ATC button is above viewport: show sticky bar
        stickyBar.classList.remove('pdp-ux-sticky-suppressed');
      } else {
        // ATC button is visible or below viewport: suppress sticky bar
        stickyBar.classList.add('pdp-ux-sticky-suppressed');
      }
    }, {
      threshold: 0
    });

    observer.observe(atcButtons);
  }

  function handleDesktopNav() {
    const subNav = document.querySelector('.sub-nav');
    const notifyButton = document.querySelector('.restock-alerts-notify-button');
    const html = document.querySelector('html');

    const stickyOffset = subNav.offsetTop;
    let lastScrollY = window.pageYOffset;

    scrollHandler = function() {
      const currentScrollY = window.pageYOffset;

      if (currentScrollY > lastScrollY && currentScrollY >= stickyOffset + 100) {
        // Scrolling down
        subNav.classList.add('sticky');
        subNav.style.top = 0;
        html.classList.add('sub-nav-desktop-active');
      } else if (currentScrollY < lastScrollY) {
        // Scrolling up
        subNav.classList.remove('sticky');
        html.classList.remove('sub-nav-desktop-active');
      }

      if (subNav && notifyButton) {
        if (subNav.classList.contains('sticky')) {
          notifyButton.style.marginBottom = '100px';
        } else {
          notifyButton.style.marginBottom = '10px';
        }
      }

      // Update the last scroll position
      lastScrollY = currentScrollY;
    };

    // Create desktop menu items.
    desktopMenuList.innerHTML = '';
    createMenuItems(desktopMenuList, 'sub-nav__menu-wrapper__menu-list__item__link sub-nav-menu-link');
    mobileMenuList.innerHTML = '';
    // Dispatch event so Contentful items can be appended.
    window.dispatchEvent(desktopEvent);

    window.addEventListener('scroll', scrollHandler);

    // Initialize sticky ATC suppression
    initStickyAtcSuppress();
  }

  function handleMobileNav() {
    const subNavMain = document.querySelector('.sub-nav__main');
    const productMain = document.querySelector('.product-main');
    const footer = document.querySelector('footer');
    const html = document.querySelector('html');
    const atcButtons = document.querySelector('.product__info-wrapper .product-form__buttons') || document.querySelector('.product-form__buttons');

    subNavMain.style.position = 'fixed';
    subNavMain.style.width = '100%';

    function updateSubNavClass() {
      const atcScrolledOut = atcButtons &&
      (atcButtons.getBoundingClientRect().bottom < 0);

      if (
        window.pageYOffset >= productMain.offsetTop &&
        !(window.pageYOffset + window.innerHeight >= footer.offsetTop) &&
        atcScrolledOut
      ) {
        subNavMain.classList.remove('sub-nav-hide');
        subNavMain.classList.add('close');
      } else {
        subNavMain.classList.remove('open', 'close');
        subNavMain.classList.add('sub-nav-hide');
        html.classList.remove('sub-nav-active');
      }
    }

    function toggleNavClass() {
      if (subNavMain.classList.contains('close')) {
        subNavMain.classList.remove('close');
        subNavMain.classList.add('open');
        html.classList.add('sub-nav-active');
      } else if (subNavMain.classList.contains('open')) {
        subNavMain.classList.remove('open');
        subNavMain.classList.add('close');
        html.classList.remove('sub-nav-active');
      }
    }

    function handleClickOutside(event) {
      if (!subNavMain.contains(event.target)) {
        subNavMain.classList.remove('open');
        subNavMain.classList.add('close');
        html.classList.remove('sub-nav-active');
        document.removeEventListener('click', handleClickOutside);
      }
    }

    scrollHandler = updateSubNavClass;
    resizeHandler = function() {
      if (window.innerWidth < 1024) {
        subNavMain.classList.add('sub-nav-hide');
        updateSubNavClass();
      }
    };

    window.addEventListener('scroll', scrollHandler);
    window.addEventListener('resize', resizeHandler);

    subNavMain.addEventListener('click', function(event) {
      event.stopPropagation();
      toggleNavClass();
      document.addEventListener('click', handleClickOutside);
    });

    if (window.innerWidth < 1024) {
      subNavMain.classList.add('sub-nav-hide');
      updateSubNavClass();
    }

    // Create mobile menu items.
    mobileMenuList.innerHTML = '';
    createMenuItems(mobileMenuList, 'mobile-list__menu-list__item__link mobile-list-menu-link');
    desktopMenuList.innerHTML = '';
    // Dispatch event so Contentful items can be added.
    window.dispatchEvent(mobileEvent);

    // Initialize sticky ATC suppression
    initStickyAtcSuppress();
  }

  function clearDesktopNav() {
    const subNav = document.querySelector('.sub-nav');
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
    }
    if (subNav) {
      subNav.classList.remove('sticky');
      subNav.style.top = '0';
    }
  }

  function clearMobileNav() {
    const subNavMain = document.querySelector('.sub-nav__main');
    const body = document.body;
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
    }
    if (resizeHandler) {
      window.removeEventListener('resize', resizeHandler);
    }
    if (subNavMain) {
      subNavMain.classList.remove('open', 'close', 'sub-nav-hide');
      subNavMain.style.position = '';
      subNavMain.style.width = '';
    }

    body.classList.remove('sub-nav-active');
  }

  function handleResize() {
    const newIsDesktop = window.innerWidth >= 1024;
    if (isDesktop !== newIsDesktop) {
      if (newIsDesktop) {
        clearMobileNav();
        handleDesktopNav();
      } else {
        clearDesktopNav();
        handleMobileNav();
      }
      isDesktop = newIsDesktop;
    }
  }

  // Initial setup
  if (isDesktop) {
    handleDesktopNav();
  } else {
    handleMobileNav();
  }

  // Handle window resize
  window.addEventListener('resize', handleResize);
});